module.exports = "<p>\n  confirmation-page works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-page/confirmation-page.component.html
// module id = ./src/app/shared/components/confirmation-page/confirmation-page.component.html
// module chunks = main